// PLZ-304: tarjeta de sellos del comercio (SPEC-FIDELIZACION-VISIBLE §6.4).
// Sin login: el cliente se reconoce por el service_id de su ultimo pedido (pleiztService).
// La API nunca devuelve nombre, telefono ni codigo del premio.
export const fetchLoyalty = async (serviceId) => {
  const company = window.location.hostname.split(".")[0];
  const query = serviceId ? `?service=${encodeURIComponent(serviceId)}` : "";
  const res = await fetch(`${process.env.REACT_APP_API_URL}/stamps/${encodeURIComponent(company)}${query}`, {
    headers: { Accept: "application/json" },
  });
  if (!res.ok) throw new Error(`stamps ${res.status}`);
  const body = await res.json();
  return body?.data?.loyalty ?? null;
};

// Luminancia relativa (0 = negro, 1 = blanco). null si el color no es un hex de 3 o 6 digitos.
export function luminance(color) {
  const m = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i.exec(String(color || "").trim());
  if (!m) return null;
  let hex = m[1];
  if (hex.length === 3) hex = hex.split("").map((c) => c + c).join("");
  const n = parseInt(hex, 16);
  const ch = (v) => {
    const s = v / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  };
  return 0.2126 * ch((n >> 16) & 255) + 0.7152 * ch((n >> 8) & 255) + 0.0722 * ch(n & 255);
}

// PLZ-308: color de texto que se lea sobre el color del comercio. Respeta el que configuro
// el comercio si se lee (contraste >= 3:1); si no (blanco sobre amarillo), oscuro o blanco.
export function readableTextOn(bg, preferred) {
  const lb = luminance(bg);
  if (lb === null) return preferred || "#FFFFFF";
  const lp = luminance(preferred);
  if (lp !== null) {
    const ratio = (Math.max(lb, lp) + 0.05) / (Math.min(lb, lp) + 0.05);
    if (ratio >= 3) return preferred;
  }
  return lb > 0.35 ? "#1A1A2E" : "#FFFFFF";
}

export const formatCOP = (value) => "$" + Math.round(Number(value) || 0).toLocaleString("es-CO");

export const formatFecha = (s) => {
  if (!s) return "";
  const d = new Date(String(s).replace(" ", "T"));
  return isNaN(d) ? "" : d.toLocaleDateString("es-CO", { day: "numeric", month: "short" });
};
